module.exports = __webpack_public_path__ + "static/portrait.51a3e335.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/portrait.png
// module id = 565
// module chunks = 35783957827783